import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import stitches from "../../theme.config.es.js";
const button = stitches.css({
  cursor: "pointer",
  appearance: "none",
  border: "none",
  borderRadius: "$round",
  lineHeight: 1,
  outline: "none",
  padding: "$dismiss-padding",
  margin: "-$dismiss-padding",
  backgroundColor: "$dismiss-background",
  "&:hover": {
    backgroundColor: "$dismiss-translucent-dark"
  },
  "&:focus": {
    outline: "$outlines$focusOutline",
    outlineOffset: "$outlines$focusOutlineOffset"
  },
  "&:active": {
    backgroundColor: "$dismiss-translucent-darker"
  }
});
const visuallyHidden = stitches.css({
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  margin: "0 -1px -1px 0",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: 1,
  whiteSpace: "nowrap"
});
const CloseButton = forwardRef(function CloseButton2({ label, className, children, ...props }, ref) {
  return /* @__PURE__ */ jsxs("button", { type: "button", ...props, className: button({ className }), ref, children: [
    /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", "aria-hidden": "true", children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 6l5-5 2 2-5 5 5 5-2 2-5-5-5 5-2-2 5-5-5-5 2-2 5 5z"
      }
    ) }),
    /* @__PURE__ */ jsxs("span", { className: visuallyHidden(), children: [
      label,
      children
    ] })
  ] });
});
export {
  CloseButton as default
};
//# sourceMappingURL=CloseButton.es.js.map
